import { DownloadRequestAssetsGridColumnItem } from './download-request-assets-grid-column-item';
import { ALL } from './download-request-assets.const';
import { IDownloadRequestAssetsGridColumn } from './download-request-assets.types';

export const DownloadRequestAssetsGridColumn = ({
  files,
  selected,
  title,
  ...rest
}: IDownloadRequestAssetsGridColumn) => {
  if (!files.length) return null;
  return (
    <div className="w-full max-w-64 flex flex-col">
      <span className="block text-md font-medium text-center mb-2">{title}</span>
      <div className="flex flex-col gap-2 overflow-y-auto rounded border h-full p-2 pl-0 max-h-[400px]">
        <DownloadRequestAssetsGridColumnItem
          {...rest}
          ignoreIcon
          item={{ id: ALL, name: ALL }}
          selected={selected?.some((s) => s.id === ALL && s.type === rest.type)}
        />
        {files.map((file, index) => (
          <DownloadRequestAssetsGridColumnItem
            {...rest}
            key={file.id + '-' + index}
            index={index}
            item={file}
            selected={selected?.some((s) => s.id === file.id && s.index === index && s.type === rest.type)}
          />
        ))}
      </div>
    </div>
  );
};
